module.exports = __webpack_public_path__ + "img/san_txt.8544f642.png";